export default __webpack_public_path__ + "static/media/rocket_anim_88.88f01a99.png";